// lazy component loading
const ContestsList = () => import(/* webpackChunkName: "bounty" */ './ContestsList.vue');
const ContestsDashboard = () => import(/* webpackChunkName: "bounty" */ './ContestsDashboard.vue');
const Contest = () => import(/* webpackChunkName: "bounty" */ './Contest.vue');
const Quest = () => import(/* webpackChunkName: "bounty" */ './contest/Quest.vue');
const Questions = () => import(/* webpackChunkName: "bounty" */ './contest/Questions.vue');

const Signees = () => import(/* webpackChunkName: "bounty" */ './Signees.vue');
const Campaigns = () => import(/* webpackChunkName: "bounty" */ './Campaigns.vue');
const Paypal = () => import(/* webpackChunkName: "bounty" */ './Paypal.vue');
const Invoicee = () => import(/* webpackChunkName: "bounty" */ './Invoice.vue');

//new contest
const NewContest = () => import(/* webpackChunkName: "bounty" */ './NewContest.vue');

//one contest
const OverView = () => import(/* webpackChunkName: "bounty" */ './contest/OverView.vue');
const OverviewAfter = () => import(/* webpackChunkName: "bounty" */ './contest/OverviewAfter.vue');
const BasicInfo = () => import(/* webpackChunkName: "bounty" */ './contest/BasicInfo.vue');
const Setting = () => import(/* webpackChunkName: "bounty" */ './contest/Setting.vue');
const Subdomain = () => import(/* webpackChunkName: "bounty" */ './contest/Subdomain.vue');
const Payment = () => import(/* webpackChunkName: "bounty" */ './contest/Payment.vue');
const Paymentopt = () => import(/* webpackChunkName: "bounty" */ './contest/Paymentopt.vue');
const Invoice = () => import(/* webpackChunkName: "bounty" */ './contest/Invoice.vue');
const ProjectList = () => import( /* webpackChunkName: "bounty" */ './contest/ProjectList.vue');
const CampaignList = () => import( /* webpackChunkName: "bounty" */ './contest/CampaignList.vue');


const Participations = () => import(/* webpackChunkName: "bounty" */ './contest/Participations.vue');
const Participation = () => import(/* webpackChunkName: "bounty" */ './contest/participations/Show.vue');

const Survey = () => import( /* webpackChunkName: "bounty" */ './contest/Survey.vue');
const SurveyAfter = () => import( /* webpackChunkName: "bounty" */ './contest/SurveyAfter.vue');
const Profile = () => import( /* webpackChunkName: "bounty" */ './contest/Profile.vue');
const ProfileAfter = () => import( /* webpackChunkName: "bounty" */ './contest/ProfileAfter.vue');

const Tos = () => import(/* webpackChunkName: "bounty" */ './contest/Tos.vue');

const Basicin = () => import(/* webpackChunkName: "bounty" */ './contest/Reports.vue');

const Edit = () => import(/* webpackChunkName: "bounty" */ './contest/Edit.vue');
const End = () => import(/* webpackChunkName: "bounty" */ './contest/End.vue');

// const Questions = () => import(/* webpackChunkName: "bounty" */ './contest/partypes/Questions.vue');
const Simple = () => import(/* webpackChunkName: "bounty" */ './contest/partypes/Simple.vue');
const Codes = () => import(/* webpackChunkName: "bounty" */ './contest/partypes/Codes.vue');
const Twitter = () => import(/* webpackChunkName: "bounty" */ './contest/partypes/Twitter.vue');


import tutorialsteps from './tutorial';
import {routerTutorialGuard} from '@/providers/tutorial'


//ROUTES
export const routes = [{
  path: 'bounty',
  redirect: {name: 'bounty.myprojects'},
  name: 'bounty',
  //empty component just for base
  component: {template: '<router-view/>'},
  meta: {
    trans: 'Bounty',
    root: true,
  },
  children: [
    //DASHBOARD
    // {
    //   path: 'dashboard',
    //   name: 'bounty.dashboard',
    //   component: ContestsDashboard,
    //   meta: {
    //     trans: 'bounty:titles.dashboard',
    //     icon: 'home',
    //   }
    // },
    //CONTESTS LIST
    {
      path: 'myprojects',
      name: 'bounty.myprojects',
      component: ContestsList,
      meta: {
        trans: 'My Projects',
        icon: 'medal',
      },
    },
    {
      path: 'campaigns',
      name: 'bounty.campaigns',
      component: NewContest,
      meta: {
        trans: 'Campaign',
        icon: 'human',
      },
    },
    {
      path: 'submissions',
      name: 'bounty.submissions',
      component: Invoicee,
      meta: {
        trans: 'Submissions',
        icon: 'human',
      },
    }, {
      path: 'rewards',
      name: 'bounty.rewards',
      component: Signees,
      meta: {
        trans: 'Rewards',
        icon: 'medal',
      },
    },
    {
      path: 'campaigndetails',
      component: Profile,
      name: 'bounty.campaigndetails',
      meta: {
        up: 'bounty.submissions',
        trans: 'Campaign Details',
      },
    }, 
    {
      path: 'newproject',
      name: 'bounty.newproject',
      component: BasicInfo,
      meta: {
        trans: 'New Project',
        up: 'bounty.myprojects',
      },
    }, 
    {
      path: 'projectlist',
      name: 'bounty.projectlist',
      component: ProjectList,
      meta: {
        trans: 'Campaigns',
        up: 'bounty.campaigns',
      },
    }, 
    {
      path: 'addnewcampaign',
      name: 'bounty.addnewcampaign',
      component: Setting,
      meta: {
        trans: 'Add New Campaign',
        up: 'bounty.campaigns',
      },
    }, {
      path: 'salesboost',
      name: 'bounty.salesboost',
      component: Payment,
      meta: {
        trans: 'Campaign Details',
        up: 'bounty.campaigns',
      },
    }, {
      path: 'fundyourbounty',
      name: 'bounty.fundyourbounty',
      component: Quest,
      meta: {
        trans: 'Fund Your Bounty',
        up: 'bounty.campaigns',
      },
    }, {
      path: 'twittercampaign',
      name: 'bounty.twittercampaign',
      component: OverView,
      meta: {
        trans: 'Sales Boost',
        up: 'bounty.campaigns',
      },
    },
    // SINGLE CONTEST VIEW
    {
      name: 'bounty.project',
      path: 'projects/:id',
      component: Contest,
      props: true,
      redirect: {
        name: 'bounty.project.dashboard'
      },
      meta: {
        trans: 'My Projects',
        up: 'bounty.myprojects',
        root: true,
      },
      children: [
        {
          path: 'dashboard',
          component: OverviewAfter,
          name: 'bounty.project.dashboard',
          meta: {
            icon: 'pencil',
            trans: 'Project',
          },
        },
        {
          path: 'campaignlist',
          name: 'bounty.project.campaignlist',
          component: CampaignList,
          meta: {
            icon: 'pencil',
            trans: 'Campaigns',
          },
        },
      ],
    },
    {
      name: 'bounty.campaign',
      path: 'campaigns/:id/:bounty_type_id',
      component: ContestsDashboard,
      props: true,
      redirect: {
        name: 'bounty.campaign.editcampaign'
      },
      meta: {
        trans: 'My Campaigns',
        up: 'bounty.projectlist',
        root: true,
      },
      children: [{
          path: 'editcampaign',
          component: Subdomain,
          name: 'bounty.campaign.editcampaign',
          meta: {
            icon: 'pencil',
            trans: 'Edit Campaign',
          },
        },
        {
          path: 'twittercampaign',
          component: Paymentopt,
          name: 'bounty.campaign.twittercampaign',
          meta: {
            icon: 'pencil',
            trans: 'Twitter Campaign',
          },
        },
        {
          path: 'salesboost',
          component: Invoice,
          name: 'bounty.campaign.salesboost',
          meta: {
            icon: 'pencil',
            trans: 'Campaign Details',
          },
        },
        {
          path: 'fundyourbounty',
          component: Survey,
          name: 'bounty.campaign.fundyourbounty',
          meta: {
            icon: 'pencil',
            trans: 'Fund Your Bounty',
          },
        },
      ],
    },
  ],
}];


// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'bounty', bundle);
}

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'bounty') {
      import(/* webpackChunkName: "bounty" */ './scss/style.scss');
    }
  });
  routerTutorialGuard(router, 'bounty', 'admin-bounty-tutorial', tutorialsteps);
}


// WEBPACK FOOTER //
// ./src/apps/bounty/index.js